import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { IoCloseSharp } from "react-icons/io5";
import Select from "react-select";
import Swal from "sweetalert2";

const RestaurantRegistrationForm = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    franchise_name: "", // Changed from outletName
    district: "",
    state: "",
    information: "", // Changed from message
    type: [],
    fssai: "",
    pincode:"", // Changed from hasFSSAI and now will be number (1 or 0)
  });
  const [loading, setLoading] = useState(false);

  const Base_Url = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleTypeChange = (selectedOptions) => {
    // Extract just the values for the API
    const typeValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData({ ...formData, type: typeValues });
  };

  const handleFSSAIChange = (e) => {
    // Convert "yes"/"no" to 1/0 for the API
    const fssaiValue = e.target.value === "yes" ? 1 : 0;
    setFormData({ ...formData, fssai: fssaiValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      // Prepare data for API with correct field names
      const apiData = {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        franchise_name: formData.franchise_name,
        type: formData.type,
        fssai: formData.fssai,
        district: formData.district,
        state: formData.state,
        information: formData.information,
        pincode: formData.pincode,
      };

      const response = await axios.post(`${Base_Url}enrollFranchise`, apiData);
      console.log(response.data);
      if (response.data) {
        await Swal.fire({
          icon: "success",
          title: "Registration Successful!",
          text: "We have received your restaurant registration form. Our team will contact you shortly.",
          confirmButtonColor: "#f97316",
        });
        setFormData({
          name: "",
          email: "",
          mobile: "",
          franchise_name: "",
          district: "",
          state: "",
          pincode: "",
          information: "",
          type: [],
          fssai: "",
        });
        onHide();
      }
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "There was an error submitting your form. Please try again.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prevData) => ({ ...prevData, mobile: value }));
  };

  const restaurantTypes = [
    { value: "restaurant", label: "Restaurant" },
    { value: "cloudkitchen", label: "Cloud Kitchen" },
    { value: "homechef", label: "Home Chef" },
    { value: "caterer", label: "Caterer" },
    { value: "cafe", label: "Cafe" },
    { value: "baker", label: "Baker" },
  ];

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Body className="restaurant-modal" closeButton>
        <button
          type="button"
          className="btn-close btn-close-white float-end"
          aria-label="Close"
          onClick={onHide}
        >
          {/* <IoCloseSharp /> */}
        </button>
        <h3 className="contact-form-banner mb-2 text-center">
          Enroll Your Restaurant Now!
        </h3>

        <h6 className="restaurant-h6-info text-center mb-3">
          Please fill your restaurant details. Our onboarding team will
          contact you shortly.
        </h6>
        <form onSubmit={handleSubmit}>
  <div className="row">
    <div className="col-md-6 mb-3">
      <input
        type="text"
        name="name"
        id="name"
        className="form-control"
        placeholder="Your Name"
        value={formData.name}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <input
        type="text"
        name="mobile"
        id="mobile"
        className="form-control"
        placeholder="Mobile Number"
        value={formData.mobile}
        onChange={handleMobileChange}
        required
        maxLength={10}
      />
    </div>
  </div>

  <div className="mb-3">
    <input
      type="email"
      name="email"
      id="email"
      className="form-control"
      placeholder="Email Address"
      value={formData.email}
      onChange={handleChange}
      required
    />
  </div>

  <div className="row">
    <div className="col-md-6 mb-3">
      <input
        type="text"
        name="franchise_name"
        id="franchise_name"
        className="form-control"
        placeholder="Restaurant/Outlet Name"
        value={formData.franchise_name}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <Select
        isMulti
        options={restaurantTypes}
        name="type"
        id="type"
        classNamePrefix="select"
        placeholder="Select Type"
        value={restaurantTypes.filter((option) =>
          formData.type.includes(option.value)
        )}
        onChange={handleTypeChange}
      />
    </div>
  </div>

  {/* FSSAI */}
  <div className="mb-3">
    <label className="form-label text-white">
      Do you have FSSAI license?
    </label>
    <div className="d-flex gap-4">
      <div className="form-check">
        <input
          type="radio"
          name="fssai"
          id="fssaiYes"
          className="form-check-input"
          value="yes"
          checked={formData.fssai === 1}
          onChange={handleFSSAIChange}
          required
        />
        <label className="form-check-label text-white" htmlFor="fssaiYes">
          Yes
        </label>
      </div>

      <div className="form-check">
        <input
          type="radio"
          name="fssai"
          id="fssaiNo"
          className="form-check-input"
          value="no"
          checked={formData.fssai === 0}
          onChange={handleFSSAIChange}
          required
        />
        <label className="form-check-label text-white" htmlFor="fssaiNo">
          No
        </label>
      </div>
    </div>
  </div>

  {/* Location Section */}
  <div className="row">
    <div className="col-md-4 mb-3">
      <input
        type="text"
        name="district"
        id="district"
        className="form-control"
        placeholder="District"
        value={formData.district}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-4 mb-3">
      <input
        type="text"
        name="state"
        id="state"
        className="form-control"
        placeholder="State"
        value={formData.state}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-4 mb-3">
      <input
        type="text"
        name="pincode"
        id="pincode"
        className="form-control"
        placeholder="Pincode"
        value={formData.pincode}
        onChange={handleChange}
        required
        maxLength={6}
        pattern="[0-9]{6}"
        inputMode="numeric"
      />
    </div>
  </div>

  <div className="mb-3">
    <textarea
      placeholder="Any additional information about your restaurant..."
      className="form-control"
      name="information"
      id="information"
      value={formData.information}
      onChange={handleChange}
      rows="3"
    />
  </div>

  <div className="text-center mt-4">
    <button
      type="submit"
      disabled={loading}
      className="btn btn-primary"
    >
      {loading ? "Submitting..." : "Submit Registration"}
    </button>
  </div>
</form>
      </Modal.Body>
    </Modal>
  );
};

export default RestaurantRegistrationForm;
